import moment from "moment";
import { useEffect } from "react";
import Loader from "../../components/loader";
import WebLayout from "../../layout/WebLayout";
import NoRecord from "../../components/NoRecord";
import PanelLayout from "../../layout/PanelLayout";
import { webPaths } from "../../routes/pageRoutes";
import { useDispatch, useSelector } from "react-redux";
import AssetCard from "../../components/pages/AssetCard";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { fetchAssetsDetail } from "../../redux/actions/assetAction";
import { handleShareAsset, pipGetAccessToken } from "../../utils/pip";

const AssetDetail = () => {
  const { id } = useParams();
  const { isLogin } = pipGetAccessToken();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const fromPage = location.state?.from;

  const { isLoading, assetData, relatedAssetList } = useSelector(
    (state) => state.assetReducer,
  );

  useEffect(() => {
    dispatch(fetchAssetsDetail(id));
  }, [id]);

  const render = () => {
    return (
      <>
        <div class="assets-detail-content ct_py_80">
          <div class="container">
            {/* Header */}
            <div class="header-section">
              <h1 class="ct_fs_24 ct_fw_600">
                {" "}
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(-1);
                  }}
                  class="ct_back_icon ct_fs_18"
                >
                  <i class="fa-solid fa-angle-left"></i>
                </a>
                {fromPage == webPaths?.MyAssets && "My"} Asset Details
              </h1>
              <div class="header-actions d-flex gap-3 flex-wrap align-items-center">
                {fromPage == webPaths?.MyAssets ? (
                  <>
                    <a
                      class="ct_text_clr_4B5563 d-flex align-items-center "
                      data-bs-target="#mobileAppModal"
                      data-bs-toggle="modal"
                    >
                      <svg
                        className="me-2"
                        width="18"
                        height="18"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17.6453 5.6767C18.0859 5.23622 18.3334 4.63876 18.3335 4.01574C18.3336 3.39273 18.0862 2.79521 17.6457 2.35462C17.2052 1.91403 16.6077 1.66646 15.9847 1.66638C15.3617 1.6663 14.7642 1.91372 14.3236 2.3542L3.20194 13.4784C3.00845 13.6713 2.86537 13.9088 2.78527 14.17L1.68444 17.7967C1.6629 17.8688 1.66127 17.9453 1.67973 18.0182C1.69819 18.0912 1.73604 18.1577 1.78927 18.2109C1.8425 18.264 1.90912 18.3018 1.98207 18.3201C2.05502 18.3384 2.13157 18.3367 2.2036 18.315L5.8311 17.215C6.09208 17.1357 6.32958 16.9934 6.52277 16.8009L17.6453 5.6767Z"
                          stroke="#4A5565"
                          stroke-width="1.66667"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M12.5 4.16675L15.8333 7.50008"
                          stroke="#4A5565"
                          stroke-width="1.66667"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Edit Asset
                    </a>
                  </>
                ) : (
                  <>
                    <a
                      class="ct_text_clr_4B5563 d-flex align-items-center"
                      data-bs-target="#mobileAppModal"
                      data-bs-toggle="modal"
                    >
                      <svg
                        className="me-2"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10.0003 13.3334V10M10.0003 6.66669H10.0087M1.66699 7.10231V12.8977C1.66699 13.1016 1.66699 13.2035 1.69002 13.2994C1.71043 13.3844 1.7441 13.4657 1.78979 13.5403C1.84133 13.6244 1.91339 13.6964 2.05752 13.8405L6.1598 17.9428C6.30393 18.087 6.37599 18.159 6.46009 18.2106C6.53465 18.2562 6.61594 18.2899 6.70097 18.3103C6.79687 18.3334 6.89878 18.3334 7.10261 18.3334H12.898C13.1019 18.3334 13.2038 18.3334 13.2997 18.3103C13.3847 18.2899 13.466 18.2562 13.5406 18.2106C13.6247 18.159 13.6967 18.087 13.8408 17.9428L17.9431 13.8405C18.0873 13.6964 18.1593 13.6244 18.2109 13.5403C18.2565 13.4657 18.2902 13.3844 18.3106 13.2994C18.3337 13.2035 18.3337 13.1016 18.3337 12.8977V7.10231C18.3337 6.89848 18.3337 6.79657 18.3106 6.70066C18.2902 6.61563 18.2565 6.53434 18.2109 6.45978C18.1593 6.37569 18.0873 6.30362 17.9431 6.1595L13.8408 2.05721C13.6967 1.91308 13.6247 1.84102 13.5406 1.78949C13.466 1.7438 13.3847 1.71013 13.2997 1.68971C13.2038 1.66669 13.1019 1.66669 12.898 1.66669H7.10261C6.89878 1.66669 6.79687 1.66669 6.70097 1.68971C6.61594 1.71013 6.53465 1.7438 6.46009 1.78949C6.37599 1.84102 6.30393 1.91308 6.1598 2.05721L2.05752 6.1595C1.91339 6.30362 1.84133 6.37569 1.78979 6.45978C1.7441 6.53434 1.71043 6.61563 1.69002 6.70066C1.66699 6.79657 1.66699 6.89848 1.66699 7.10231Z"
                          stroke="#4A5565"
                          stroke-width="1.66667"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Report Asset
                    </a>
                    <a
                      // onClick={(e) => {
                      //   e.preventDefault();
                      //   navigate(webPaths?.SavedAsset);
                      // }}

                      data-bs-toggle="modal"
                      data-bs-target="#mobileAppModal"
                      class="ct_text_clr_4B5563 d-flex align-items-center"
                    >
                      <svg
                        className="me-2"
                        width="14"
                        height="19"
                        viewBox="0 0 14 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2 0.5H12C12.8284 0.5 13.5 1.17157 13.5 2V18.1035L7.2627 14.2559L7 14.0947L6.7373 14.2559L0.5 18.1035V2C0.5 1.17157 1.17157 0.5 2 0.5Z"
                          stroke="#4A5565"
                        />
                      </svg>
                      Save Asset
                    </a>
                  </>
                )}
                <a
                  class="ct_text_clr_4B5563 d-flex align-items-center"
                  // data-bs-target="#mobileAppModal"
                  // data-bs-toggle="modal"
                  onClick={() => {
                    handleShareAsset(assetData?.id);
                  }}
                >
                  <svg
                    className="me-2"
                    width="18"
                    height="18"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.8335 3.33337V6.66671C5.35432 7.52337 3.31682 12.3234 2.50016 16.6667C2.46932 16.8384 6.98682 11.6984 10.8335 11.6667V15L17.5002 9.16671L10.8335 3.33337Z"
                      stroke="#4A5565"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Share
                </a>
              </div>
            </div>

            {/* Main Content Card */}
            <div class="content-card">
              <div class="card-body-custom">
                <div class="row g-4 align-items-center ct_mb_30">
                  {/* Image Column */}
                  <div class="col-lg-4">
                    <div class="image-section">
                      <img
                        src={
                          assetData?.AssetImages
                            ? assetData?.AssetImages[0]?.image_url
                            : "/assets/img/assets_1.png"
                        }
                        alt="asset img"
                      />
                      {fromPage == webPaths?.MyAssets ? (
                        assetData?.lock == 0 ? (
                          <div className="lock-badge">
                            <svg
                              width="20"
                              height="28"
                              viewBox="0 0 20 28"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M18.3333 12.3125H16.6667V7.25C16.6667 3.5375 13.6667 0.5 10 0.5C6.33333 0.5 3.33333 3.5375 3.33333 7.25V12.3125H1.66667C0.833333 12.3125 0 13.1562 0 14V25.8125C0 26.6562 0.833333 27.5 1.66667 27.5H18.3333C19.1667 27.5 20 26.6562 20 25.8125V14C20 13.1562 19.1667 12.3125 18.3333 12.3125ZM11.6667 24.125H8.33333L9 20.4125C8.16667 20.075 7.5 19.0625 7.5 18.2188C7.5 16.8687 8.66667 15.6875 10 15.6875C11.3333 15.6875 12.5 16.8687 12.5 18.2188C12.5 19.2313 12 20.075 11 20.4125L11.6667 24.125ZM13.3333 12.3125H6.66667V7.25C6.66667 5.39375 8.16667 3.875 10 3.875C11.8333 3.875 13.3333 5.39375 13.3333 7.25V12.3125Z"
                                fill="#32CD30"
                              />
                            </svg>
                          </div>
                        ) : (
                          <div className="lock-badge">
                            <svg
                              width="21"
                              height="28"
                              viewBox="0 0 21 28"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M13.6 11.9V6.8C13.6 4.93 12.07 3.4 10.2 3.4C8.33 3.4 6.8 4.93 6.8 6.8H3.4C3.4 3.043 6.443 0 10.2 0C13.957 0 17 3.043 17 6.8V11.9H18.7C19.635 11.9 20.4 12.665 20.4 13.6V25.5C20.4 26.435 19.635 27.2 18.7 27.2H1.7C0.764999 27.2 0 26.435 0 25.5V13.6C0 12.665 0.764999 11.9 1.7 11.9H13.6ZM11.9 23.8L11.288 20.145C12.155 19.737 12.75 18.87 12.75 17.85C12.75 16.439 11.611 15.3 10.2 15.3C8.789 15.3 7.65 16.439 7.65 17.85C7.65 18.87 8.245 19.737 9.112 20.145L8.5 23.8H11.9Z"
                                fill="#32CD30"
                              />
                            </svg>
                          </div>
                        )
                      ) : assetData?.lock == 0 ? (
                        <div className="lock-badge" style={{ right: "-15px" }}>
                          <svg
                            width="20"
                            height="28"
                            viewBox="0 0 20 28"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M18.3333 12.3125H16.6667V7.25C16.6667 3.5375 13.6667 0.5 10 0.5C6.33333 0.5 3.33333 3.5375 3.33333 7.25V12.3125H1.66667C0.833333 12.3125 0 13.1562 0 14V25.8125C0 26.6562 0.833333 27.5 1.66667 27.5H18.3333C19.1667 27.5 20 26.6562 20 25.8125V14C20 13.1562 19.1667 12.3125 18.3333 12.3125ZM11.6667 24.125H8.33333L9 20.4125C8.16667 20.075 7.5 19.0625 7.5 18.2188C7.5 16.8687 8.66667 15.6875 10 15.6875C11.3333 15.6875 12.5 16.8687 12.5 18.2188C12.5 19.2313 12 20.075 11 20.4125L11.6667 24.125ZM13.3333 12.3125H6.66667V7.25C6.66667 5.39375 8.16667 3.875 10 3.875C11.8333 3.875 13.3333 5.39375 13.3333 7.25V12.3125Z"
                              fill="#32CD30"
                            />
                          </svg>
                        </div>
                      ) : (
                        <div className="lock-badge" style={{ right: "-15px" }}>
                          <svg
                            width="21"
                            height="28"
                            viewBox="0 0 21 28"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M13.6 11.9V6.8C13.6 4.93 12.07 3.4 10.2 3.4C8.33 3.4 6.8 4.93 6.8 6.8H3.4C3.4 3.043 6.443 0 10.2 0C13.957 0 17 3.043 17 6.8V11.9H18.7C19.635 11.9 20.4 12.665 20.4 13.6V25.5C20.4 26.435 19.635 27.2 18.7 27.2H1.7C0.764999 27.2 0 26.435 0 25.5V13.6C0 12.665 0.764999 11.9 1.7 11.9H13.6ZM11.9 23.8L11.288 20.145C12.155 19.737 12.75 18.87 12.75 17.85C12.75 16.439 11.611 15.3 10.2 15.3C8.789 15.3 7.65 16.439 7.65 17.85C7.65 18.87 8.245 19.737 9.112 20.145L8.5 23.8H11.9Z"
                              fill="#32CD30"
                            />
                          </svg>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Details Column */}
                  <div class="col-lg-7 offset-lg-1">
                    <div class="d-flex justify-content-between align-items-start mb-3 ct_flex_col_575 gap-3">
                      <div>
                        <h2 class="asset-title text-capitalize">
                          {assetData?.AssetName || "#N/A"}
                        </h2>
                        <p class="asset-meta mb-0">
                          Last updated:{" "}
                          {moment(assetData?.updatedAt).format(
                            "MMMM D, YYYY • h:mm A",
                          )}
                        </p>
                      </div>
                      {fromPage == webPaths?.MyAssets ? (
                        <button
                          class="outline_btn ct_white_nowrap"
                          data-bs-target="#mobileAppModal"
                          data-bs-toggle="modal"
                        >
                          Promote Asset
                        </button>
                      ) : (
                        <button
                          class="outline_btn ct_white_nowrap"
                          onClick={() =>
                            navigate(`/user-detail/${assetData?.user?.id}`)
                          }
                        >
                          Contact Owner
                        </button>
                      )}
                    </div>

                    <div class="asset-links d-flex gap-4">
                      <a href="#" class="asset-link ct_text_clr_4B5563">
                        UIC:
                        <span class="ct_text_color_009966">
                          {assetData?.UIC}
                        </span>
                      </a>
                      <a
                        target="_blank"
                        href={`https://www.google.com/maps?q=${assetData?.latitude},${assetData?.longitude}`}
                        // onClick={(e) => {
                        //   e.preventDefault();
                        // }}
                        class="asset-link ct_blue_text"
                      >
                        <i class="fa-solid fa-location-dot me-1"></i>
                        View on map
                      </a>
                    </div>

                    {/* {assetData?.isVisible && ( */}
                    <div>
                      <div class="warning-banner">
                        <i class="fa-solid fa-triangle-exclamation"></i>
                        This asset is not available!
                      </div>
                    </div>
                    {/* )} */}
                  </div>
                </div>

                <div>
                  <h3 class="ct_fs_22 ct_switzer_Semibold mb-3">
                    Asset Information
                  </h3>
                  <div class="ct_para_scroll ct_custom_scroll">
                    <p
                      class="asset-description ct_switzer_Regular ct_fs_17"
                      style={{ color: "#364153" }}
                    >
                      {assetData?.AssetDetails || "#N/A"}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <section class="ct_py_80 pt-0">
          {fromPage == webPaths?.MyAssets ? (
            <div class="container">
              <div class="row">
                <div class="col-md-12">
                  <div class="text-center">
                    <h4 class="ct_green_text ct_fs_32 ct_fw_600 ct_switzer_Semibold">
                      Promote Asset
                    </h4>
                    <p class="mb-0 ct_text_clr_4B5563s ct_fs_18 ct_switzer_Regular">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiu
                    </p>

                    <button
                      class="ct_green_bnt px-5 mx-auto ct_mt_30 ct_border_radius_12_new"
                      style={{ background: "#00C950" }}
                      data-bs-target="#mobileAppModal"
                      data-bs-toggle="modal"
                    >
                      Boost
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div class="container">
              <div class="row">
                <div class="col-md-12">
                  <div class="d-flex align-items-center justify-content-between mb-2">
                    <div>
                      <h5 class="ct_fs_32 ct_switzer_Semibold">
                        {" "}
                        Related Items
                      </h5>
                    </div>
                    <a
                      onClick={(e) => {
                        e.preventDefault();
                        navigate(webPaths?.AllAssets);
                      }}
                      class="ct_text_clr_4B5563"
                    >
                      View More <i class="fa-solid fa-angle-right ms-1"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div className="ct_assets_data ct_custom_scroll pb-4">
                <div class="row">
                  {relatedAssetList?.length > 0 ? (
                    relatedAssetList?.map((item, index) => (
                      <AssetCard
                        data={
                          item
                          //   {
                          //   promote: 1,
                          //   AssetImages: [
                          //     {
                          //       image_url: "/assets/img/assets_1.png",
                          //     },
                          //   ],
                          //   id: index + 1,
                          //   latitude: "",
                          //   longitude: "",
                          //   lock: index % 2 == 0 ? 1 : 0,
                          //   UIC: "6568520",
                          //   AssetName: "iPhone 15",
                          //   isStolen: index % 2 == 0 ? true : false,
                          //   AssetDetails:
                          //     "This property is not available for sale. Kindly...",
                          // }
                        }
                      />
                    ))
                  ) : (
                    <NoRecord />
                  )}
                </div>
              </div>
            </div>
          )}
        </section>
      </>
    );
  };

  if (isLoading) {
    return <Loader />;
  }

  return isLogin ? (
    <PanelLayout>{render()}</PanelLayout>
  ) : (
    <WebLayout>{render()}</WebLayout>
  );
};

export default AssetDetail;
